import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/totalVisitsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { FILTER_OPTIONS } from "../constants";

export const GroupByFilter = () => {
  const dispatch = useDispatch();

  const selectedGroupByOptions = useSelector((state) => state.totalVisits.selectedFilters.group_by);

  return (
    <MultiSelectDropdown
      options={FILTER_OPTIONS.groupBy}
      selectedFilters={selectedGroupByOptions}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ group_by: data }))}
    />
  );
};
